import type {
  CarTripCreate,
  CarTripDay,
  CarTripDayCreate,
  CarTripDayUpdate,
  CarTripUpdate,
  NestedCarTrip,
} from '../../types/CarTripTypes';
import { API_URL, fetchApi } from './client';

/**
 * Get all car trips
 */
export const getCarTrips = async (): Promise<NestedCarTrip[]> => {
  return fetchApi<NestedCarTrip[]>(`${API_URL}/car-trips`);
};

/**
 * Get a car trip by ID
 */
export const getCarTripById = async (id: number): Promise<NestedCarTrip> => {
  return fetchApi<NestedCarTrip>(`${API_URL}/car-trips/${id}`);
};

/**
 * Create a new car trip
 */
export const createCarTrip = async (carTrip: CarTripCreate): Promise<NestedCarTrip> => {
  return fetchApi<NestedCarTrip>(`${API_URL}/car-trips`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(carTrip)
  });
};

/**
 * Update a car trip
 */
export const updateCarTrip = async (id: number, carTrip: CarTripUpdate): Promise<NestedCarTrip> => {
  return fetchApi<NestedCarTrip>(`${API_URL}/car-trips/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(carTrip)
  });
};

/**
 * Delete a car trip
 */
export const deleteCarTrip = async (id: number): Promise<void> => {
  await fetchApi<void>(`${API_URL}/car-trips/${id}`, {
    method: 'DELETE'
  });
};

export const addCarTripDay = async (
  tripId: number,
  day: CarTripDayCreate
): Promise<CarTripDay> => {
  return fetchApi<CarTripDay>(`${API_URL}/car-trips/${tripId}/days`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(day)
  });
};

export const updateCarTripDay = async (
  tripId: number,
  dayId: number,
  day: CarTripDayUpdate
): Promise<CarTripDay> => {
  return fetchApi<CarTripDay>(`${API_URL}/car-trips/${tripId}/days/${dayId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(day)
  });
};

export const deleteCarTripDay = async (tripId: number, dayId: number): Promise<void> => {
  await fetchApi<void>(`${API_URL}/car-trips/${tripId}/days/${dayId}`, {
    method: 'DELETE'
  });
};
